var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-select',{model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},_vm._l((_vm.federations),function(fed,index){return _c('option',{key:index,domProps:{"value":fed}},[_vm._v(" "+_vm._s(fed.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }